import FullWidthImageContainer from '../components/FullWidthImageContainer'
import Layout from '../components/Layout'
import React from 'react'

export default class OutletPage extends React.Component {
  render() {
    const outlets = [
      {
        title: 'Sunway Pyramid Shopping Mall',
        mapLink: 'https://goo.gl/maps/CuxVz7oqKzD2',
        imageUrl: '/img/outlets/sunway_pyramid_outlet.jpg',
        address:
          'Lot OB5, G-2 Oasis Boulevard, Ground Floor, Sunway Pyramid Shopping Mall, No. 3 Jalan PJS 11/15, Bandar Sunway, 47500 Selangor.',
      },
      {
        title: 'Lot 10 Shopping Centre',
        mapLink: 'https://goo.gl/maps/bB1h65pVqYE2',
        imageUrl: '/img/outlets/lot_10.jpg',
        address:
          'F30, 1st Floor, Lot 10 Shopping Centre, 50 Jalan Sultan Ismail, 50250 Kuala Lumpur.',
      },
      {
        title: 'Sunway Velocity Mall',
        mapLink: 'https://goo.gl/maps/ArYeVCTdqmH2',
        imageUrl: '/img/outlets/sunway_velocity.jpg',
        address:
          '1-03, First Floor, Sunway Velocity Mall, Lingkaran SV,Sunway Velocity, 55100 Kuala Lumpur.',
      },
      {
        title: '1 Utama Shopping Centre',
        mapLink: 'https://goo.gl/maps/D84fNwihEtk',
        imageUrl: '/img/outlets/one_u.jpg',
        address:
          'Lot No G129A, 1 Utama Shopping Centre. No 1 Lebuh Bandar Utama, Bandar Utama Damansara, 47800 Petaling Jaya, Selangor.',
      },
      {
        title: 'Kuantan City Mall',
        mapLink: 'https://goo.gl/maps/e55jCTtuApQ2',
        imageUrl: '/img/outlets/kuantan_city_mall.jpg',
        address:
          'GF-20, Ground floor, Kuantan City Mall, 25300 Kuantan, Pahang.',
      },
      {
        title: 'Mid Valley Megamall',
        mapLink: 'https://goo.gl/maps/wvfeiv42Aiy',
        imageUrl: '/img/outlets/mid_valley.jpg',
        address:
          'T-053, 3rd Floor, Mid Valley Megamall, Mid Valley City, Lingkaran Syed Putra, 59200 Kuala Lumpur.',
      },
    ]

    return (
      <Layout>
        <FullWidthImageContainer
          imageUrl="/img/outlets/location.jpg"
          title="Experience Caffe Bene"
          description="Find the nearest Caffe Bene to you."
        />

        <div className="section">
          <div className="container">
            <div className="column">
              <h1 className="title">Locations</h1>
              <div className="columns has-text-centered is-multiline">
                {outlets.map(outlet => (
                  <div
                    key={outlet.title}
                    className="column is-20-percent-desktop is-6-tablet"
                  >
                    <a
                      href={outlet.mapLink}
                      className="no-link"
                      target="_blank"
                    >
                      <img src={outlet.imageUrl} alt=""></img>
                      {/* <Img fluid={outlet.imageUrl.childImageSharp.fluid} alt=""/> */}
                      <h3 className="is-size-7 has-text-weight-bold">
                        {outlet.title}
                      </h3>
                    </a>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        {/* Section asked to be removed */}
        {/* <div className="has-text-centered has-bg-brand-light outlets-footer">
          <div class="column is-10 is-offset-1  pd-tb-4">
            <div class="column is-6 is-offset-3">
              <h1 className="title border-b-c black-btm">Looking for Franchise?</h1> <p>Are you interested to know more about Franchising
    Opportunities with Caffe Bene?</p>
  <br/>
  <Link to="/opportunities" class="brand-color has-text-weight-bold his-uppercase">More Info</Link>
    </div>
          </div>
        </div> */}
      </Layout>
    )
  }
}
